import { INPUT_SIZE } from '../types';
import { Input, InputProps } from './Input';

interface SearchBarProps extends InputProps {}

export const SearchBar = (props: SearchBarProps) => {
  return <Input {...props} prefixIcon="search" allowClear size={INPUT_SIZE.SMALL} />;
};
